export enum UserType {
  Host = 1,
  Guest = 2,
  NotifyHost = 3,
}
